import loadable from '@loadable/component';
const Blogs = loadable(() => import('./Components'));
export default Blogs;
